import { render, staticRenderFns } from "./index.vue?vue&type=template&id=69c307f9"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69c307f9')) {
      api.createRecord('69c307f9', component.options)
    } else {
      api.reload('69c307f9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=69c307f9", function () {
      api.rerender('69c307f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/luckyWheel/index.vue"
export default component.exports